import { API_ROUTES } from '@/constants/apiRoutes';
import type { ApiResponse } from '@/react-query/context/ApiClientContextController';
import type { AxiosInstance } from 'axios';
import type { BankInformation, ManageBankInformationPayload } from './payment.types';

const manageBankInformation = (client: AxiosInstance) => async (payload: ManageBankInformationPayload) =>
  (await client.post<ApiResponse<BankInformation>>(API_ROUTES.MANAGE_BANK_INFORMATION, payload)).data;

export const paymentMutations = {
  manageBankInformation,
};
